<template>
    <div class="record-appraisal-list">
        <ul class="list-unstyled mb-0">
            <li v-for="appraisal in appraisals" :key="appraisal.id" class="record-appraisal-list-item mb-2">
                <a :href="getAppraisalDetailUrl(appraisal.id)">
                    Forderung #{{ appraisal.attributes.appraisalNumber }}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'RecordAppraisalList',
        props: {
            appraisals: {
                required: true,
                type: Array,
            },
            recordId: {
                required: true,
                type: Number,
            },
        },
        methods: {
            getAppraisalDetailUrl(appraisalId) {
                return `/de/Schaden-Manager/Akte/Detail/vehicleDamageRecordId/${this.recordId}`
                    + `/cost-units/appraisals/${appraisalId}`;
            },
        },
    }
</script>
